<template>
	<div class="run-news">
		<div class="mb-2">
			<span class="title">עדכונים</span>
		</div>
		<div class="wrapper" :style="cssVars">
			<div class="marquee" ref="marquee">
				<div v-for="(item, index) in updates" :key="item.id">
					<div class="content">{{item.content}}</div>
					<div class="date-container">
						<span>{{item.heb_date}}</span>
						<span>|</span>
						<span>{{time(item.created_at)}}</span>
					</div>
					<img v-if="index +1 < item.length" src="img/Asset 11.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "run-news",
		components: {  },
		data() {
			return {
				marqueeOption: {
					moveTime: 4000,
					needRestTime: false,
					restTime: 500,
					needHover: true,
					delayTime: 0
				},
				marqueeHeight: ""
			};
		},
		computed: {
			updates() {
				return this.$store.state.UpdateModule.updates.filter(
					update => update.type === "run" && update.active
				);
			},
			cssVars() {
				return {
					"--marquee-height": -this.marqueeHeight + "px",
					"--marquee-speed": (this.marqueeHeight / 18) + "s"
				};
			}
		},
		methods: {
			time(created_at) {
				return moment(created_at).format("H:m");
			}
		},
		watch: {
			updates(newValue, oldValue) {
				if (newValue.length) {
					this.$nextTick().then(() => {
						this.marqueeHeight = this.$refs.marquee.offsetHeight;
					});
				}
			}
		}
	};
</script>

<style scoped>
@keyframes marquee {
  0% {
    top: 450px;
  }
  100% {
    top: var(--marquee-height);
  }
}

.marquee {
  top: 450px;
  position: relative;
  box-sizing: border-box;
  animation: marquee var(--marquee-speed) linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

.wrapper {
  overflow: hidden;
  height: 450px;
  position: relative;
}

.run-news {
  background-color: #0694d4;
  color: white;
  padding: 15px 10px;
  margin: 0 15px;
  height: 500px;
}

.item {
  margin-top: 15px;
}

.title {
  font-weight: bold;
  border-bottom: 1.5px solid white;
  margin: 0 15px;
}

.date-container {
  font-size: 14px;
  margin-bottom: 20px;
  color: #dfdddd;
}
</style>

